// Helper to process first identifier only and discard the others.
function touchHandler() {
  let touchId = -1

  const _getTouchEvent = (event) => {
    for (let i = 0; i < event.changedTouches.length; i += 1) {
      const touch = event.changedTouches.item(i)
      if (touch.identifier === touchId) return touch
    }

    return null
  }

  return {
    start(event) {
      if (touchId !== -1) return null
      touchId = event.changedTouches.item(0).identifier

      return _getTouchEvent(event)
    },

    // Get the touch event that match with the touch-id stored.
    get(event) {
      return _getTouchEvent(event)
    },

    end(event) {
      const touchEvent = _getTouchEvent(event)
      if (!touchEvent) return null
      touchId = -1

      return touchEvent
    },
  }
}

export default touchHandler
